import { render, staticRenderFns } from "./typeTag.vue?vue&type=template&id=795b19a8&scoped=true"
import script from "./typeTag.vue?vue&type=script&lang=js"
export * from "./typeTag.vue?vue&type=script&lang=js"
import style0 from "./typeTag.vue?vue&type=style&index=0&id=795b19a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b19a8",
  null
  
)

export default component.exports